import React from 'react';
import Input from '../Input';

const modules = [
    {
        type: 'type',
        template: 'Select',
        label: 'Input Type',
        options: [
            { label: 'Text', value: 'text' },
            { label: 'Email', value: 'email' },
            { label: 'Textarea', value: 'textarea' },
        ],
    },
    {
        type: 'label',
        label: 'Label',
        template: 'Input',
        placeholder: 'Label Text',
    },
    {
        type: 'placeholder',
        label: 'Placeholder',
        template: 'Input',
        placeholder: 'Placeholder Text',
    },
];

function FormFields(props) {
    const defaultFields = [
        {
            id: 2,
            type: 'email',
            name: 'email',
            required: true,
            label: 'Your Email',
            placeholder: 'Enter Email Address',
            validate: '[a-zA-Z0-9]',
        },
        {
            id: 1,
            type: 'text',
            name: 'text',
            required: true,
            label: 'Your Name',
            placeholder: 'Enter Name',
            validate: '[a-zA-Z0-9]',
        },
    ];

    const handleChange = (value, index) => {
        console.log('ANWARN', { value, index });
    };

    return defaultFields.map((field, index) => (
        <RenderTemplate
            key={field.id}
            modules={modules}
            item={field}
            onChange={handleChange}
            index={index}
        />
    ));
}

export default FormFields;

function RenderTemplate({ modules, onChange, item, index }) {
    const handleChange = (value) => {
        onChange(value, index);
    };
    return modules.map((mod, index) => (
        <Input onChange={handleChange} key={index} value={item[mod.type]} />
    ));
}
